module.exports = __webpack_public_path__ + "static/media/sixth_lookout_tower3.051997c2.jpg";